<template>
  <div v-if="Array.isArray(data) && data.length">
    <component
      :is="resolveSectionComponent(section.__typename as SectionComponents)"
      v-for="section in data"
      :key="section.__typename"
      :data="section"
    />
  </div>
</template>

<script setup lang="ts">
import { SectionComponents } from '~/types/components'
import { ProgramProductModelBlocksField } from '~/types/generated'
defineProps({
  data: {
    type: Array as PropType<ProgramProductModelBlocksField[]>,
    default: () => {}
  }
})
const { resolveSectionComponent } = useResolveComponent()
</script>
